import React, { useState, useEffect } from 'react';
import uploadIcon from '../assets/icons/rawdata/uploadIcon.svg';
import ArrowRightOutlined from '../assets/icons/rawdata/Modal_arrow.svg';
import dynamicIcon from '../assets/icons/rawdata/file.svg'; // Example dynamic icon
import endIcon from '../assets/icons/rawdata/delete.svg'; // Example end icon
import { useDispatch, useSelector } from 'react-redux'
import { deleteCasperIdAttachments, fetchCasperIdAttachments, uploadDocument } from '../features/Certificate/CertificateSlice';
import { message, Spin } from 'antd';

const CertificateDetails = ({ heading, subheading, files, handleCancel, isCertificationModalVisible, casperId, imoNumber, requestedEntity }) => {
  const [fileList, setFileList] = useState([]);
  const { casperData, uploadStatus } = useSelector((state) => state.certificate)
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch()


  useEffect(() => {
    if (casperData) {
      let initialFiles = [];
      let requestedType = '';
      switch (requestedEntity) {
        case 'feedstock_poo_urls':
          initialFiles = casperData.feedstock_poo_urls || [];
          requestedType = 'feedstock_poo_urls';
          break;
        case 'first_gathering_point_urls':
          initialFiles = casperData.first_gathering_point_urls || [];
          requestedType = 'first_gathering_point_urls';
          break;
        case 'trader_urls':
          initialFiles = casperData.trader_urls || [];
          requestedType = 'trader_urls';
          break;
        case 'prod_to_bunkering_urls':
          initialFiles = casperData.prod_to_bunkering_urls || [];
          requestedType = 'prod_to_bunkering_urls';
          break;
        case 'bunkering_to_usage_urls':
          initialFiles = casperData.bunkering_to_usage_urls || [];
          requestedType = 'bunkering_to_usage_urls';
          break;
        case 'verified_emission_statement_url':
          initialFiles = casperData.verified_emission_statement_url ? [casperData.verified_emission_statement_url] : [];
          requestedType = 'verified_emission_statement_url';
          break;
        default:
          initialFiles = [];
          requestedType = 'Unknown';
      }


      const formattedFiles = initialFiles?.map((url) => ({
        name: url.split('/').pop(), // Extract file name from URL
        uploadDate: 'Already Uploaded',
        url,
        attachment_type: requestedType
      }));
      setFileList([...formattedFiles, ...files]);
    } else {
      setFileList([]);
    }
  }, [casperData, heading]);

  const handleFileUpload = (event) => {
    const newFiles = Array.from(event.target.files);
    const now = new Date();
    const formattedDate = `${now.toLocaleTimeString()} ${now.toLocaleDateString()}`;

    const fileData = newFiles.map((file) => ({
      name: file.name,
      uploadDate: formattedDate,
      category: getCategoryFromHeading(requestedEntity),
      file,
    }));

    const updatedFileList = [...fileList];
    fileData.forEach((file) => {
      if (!updatedFileList.some((existingFile) => existingFile.name === file.name)) {
        updatedFileList.push(file);
      }
    });

    setFileList(updatedFileList);
    dispatchUpload(updatedFileList);
  };

  const getCategoryFromHeading = (heading) => {
    switch (heading) {
      case 'feedstock_poo_urls':
        return 'feedstock_poo_files';
      case 'first_gathering_point_urls':
        return 'first_gathering_files';
      case 'trader_urls':
        return 'trader_urls';
      case 'prod_to_bunkering_urls':
        return 'prod_to_bunkering_urls';
      case 'bunkering_to_usage_urls':
        return 'bunkering_to_usage_urls';
      case 'verified_emission_statement_url':
        return 'verified_emission_statement_url';
      default:
        return 'Unknown';
    }
  };
  useEffect(() => {
    const fileInput = document.getElementById('fileUpload');
    fileInput.value = ''; // Reset file input value to allow re-upload
  }, [heading]);
  const dispatchUpload = (updatedFiles) => {

    const payload = {
      files: updatedFiles.filter((file) => file.file), // Only include files with a `file` object
      casper_id: casperId,
      imo_number: imoNumber,
    };
    dispatch(uploadDocument(payload))
      .then((result) => {
        dispatch(fetchCasperIdAttachments({ imoNumber: imoNumber, casperId: casperId }))
        setFileList([]);
        if (result.payload === "successfully saved and uploaded") {
          message.success('File uploaded successfully!');
        } else {
          message.error('File size should be less than 1MB!');
        }
      })
      .catch((error) => {
        console.error(error);
        message.error('Failed to upload file. Please try again.'); // Show error message
      })
      .finally(() => {
        setLoading(false); // Hide loader
      });
  };

  const handleFileRemove = (data, indexToRemove) => {
    if (data.file) {
      // Locally uploaded file
      const updatedFileList = fileList.filter((_, index) => index !== indexToRemove);
      setFileList(updatedFileList);
      dispatchUpload(updatedFileList);
    } else {
      // Already uploaded file
      const payload = {
        ...data,
        casper_id: casperData.casper_id,
        imo_number: casperData.imo_number_id,
      };
      dispatch(deleteCasperIdAttachments(payload)).then(() => {

        dispatch(fetchCasperIdAttachments({ imoNumber: casperData.imo_number_id, casperId: casperData.casper_id }))
        message.success('File deleted successfully!'); // Success message after delete
        handleCancel();
      });
    }
  };

  const dynamicDatas = {
    icon: dynamicIcon, // Replace with dynamic icon path
    endIcon: endIcon, // Replace with dynamic end icon path
  };

  const handleDownload = (url) => {
    if (!url) {
      alert("Invalid URL!");
      return;
    }

    // Create an anchor element dynamically
    const link = document.createElement("a");
    link.href = url;
    link.download = ""; // Provide a default filename if needed (e.g., "file.txt")

    // Append the link to the body
    document.body.appendChild(link);

    // Trigger the click event to start the download
    link.click();

    // Remove the link from the DOM
    document.body.removeChild(link);

    // alert("File download started!");
  };

  return (


    <div className="cert-container">

      <div className="cert-header">
        <div className="cert-headerText">
          <span>{heading}</span>
          <img
            src={ArrowRightOutlined}
            alt="arrow icon"
            className="cert-arrowIcon"
          />
        </div>
      </div>
      <div className="cert-subheading">
        {subheading}
      </div>
      <hr className="cert-separator" />
      {uploadStatus === "pending" ? <Spin tip="Uploading..." /> :
        <div className="cert-dynamicDiv" style={{ maxHeight: '100%', overflowY: 'scroll' }}>

          {fileList.map((file, index) => (
            <div key={index} className="cert-fileEntry" style={{ marginBottom: '10px', cursor: 'pointer' }} >
              <img src={dynamicDatas.icon} alt="dynamic icon" className="cert-dynamicIcon" />
              <div className="cert-dynamicContent" onClick={() => handleDownload(file?.url)}>
                <div className="cert-dynamicHeading">{file.name}</div>
                <div className="cert-dynamicSubheading">{file.uploadDate}</div>
              </div>
              <img
                src={dynamicDatas.endIcon}
                alt="end icon"
                className="cert-dynamicEndIcon"
                onClick={() => handleFileRemove(file, index)} // Handle the click event
                style={{ cursor: 'pointer' }}
              />
            </div>
          ))}
        </div>
      }

      <div className="cert-footer">
        <div className="cert-fileCount">{fileList.length} Files added</div>
        <input
          type="file"
          id="fileUpload"
          style={{ display: 'none' }}
          onChange={handleFileUpload}
        // multiple
        />
        <label htmlFor="fileUpload" className="cert-uploadButton">
          <img src={uploadIcon} alt="upload icon" className="cert-uploadIcon" />
          Upload
        </label>
      </div>
    </div>

  );
};

export default CertificateDetails;
